import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';
import { firmInfo } from '../data/mock';

const SocialButtons = () => {
  return (
    <>
      {/* Instagram Button */}
      <a
        href={firmInfo.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-24 left-6 w-14 h-14 bg-gradient-to-br from-pink-500 to-purple-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-40 flex items-center justify-center group"
        aria-label="Follow on Instagram"
      >
        <Instagram className="w-6 h-6" />
        <span className="absolute left-full ml-3 bg-gray-900 text-white text-sm px-3 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Follow Us
        </span>
      </a>

      {/* LinkedIn Button */}
      <a
        href={firmInfo.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-42 left-6 w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-40 flex items-center justify-center group"
        style={{ bottom: '10.5rem' }}
        aria-label="Connect on LinkedIn"
      >
        <Linkedin className="w-6 h-6" />
        <span className="absolute left-full ml-3 bg-gray-900 text-white text-sm px-3 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Connect on LinkedIn
        </span>
      </a>
    </>
  );
};

export default SocialButtons;
